//ai-public-search-morelikethis-token-manager.js

async function publicSearchAuthFetch(url, options = {}, retry = true) {
  if (!window.GoddivaAiAuth) {
    console.error('GoddivaAiAuth not loaded - check script load order');
    return null;
  }
  return window.GoddivaAiAuth.authFetch(url, options, retry);
}

/* ===============================
   SHARED: CONSTANTS
=============================== */
const PUBLIC_SEARCH_CONFIG = {
  SEARCH_URL: 'https://ai.mygoddiva.com/public-product-search',
  SUGGESTION_URL: 'https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-suugestion-ignore_new_1_1_1.json?v=1760464442',
  // Relative path → same-origin, no CORS, works on any domain (stage/live/preview).
  // The `view=best-sellers` template must render JSON
  // (Shopify alternate template: templates/collection.best-sellers.liquid).
  BEST_SELLERS_PATH: '/collections/best-sellers?view=best-sellers',
  MIN_QUERY_LENGTH: 3,
  RESULTS_PAGE_PATH: '/pages/ai-search-result',
};

const PUBLIC_SEARCH_STOPWORDS = [
  'i','me','my','mine','you','your','yours',
  'am','is','are','was','were','be','been','being',
  'do','does','did','done',
  'have','has','had','having',
  'will','would','shall','should','can','could','may','might','must',
  'a','an','the',
  'for','to','in','on','at','with','of','by','about',
  'and','or','but','if','than','then',
  'this','that','these','those',
  'here','there',
  'looking','searching','want','need','find','show','give','get',
  'yahoo','gmail','hotmail','outlook','aol','icloud','protonmail',
  'com','co','uk','net','org','gov','edu','info','biz',
  '@','return','order','status','policy','code','qr','label','tracking','delivery','payment','discount','email','name','ret',
];

const PUBLIC_SEARCH_SYNONYMS = {
  // ===== Existing entries =====
  rad: 'red',
  retorn: 'return',
  retrn: 'return',
  reurn: 'return',
  adress: 'address',
  ordr: 'order',

  // ===== Colours =====
  blak: 'black',
  blck: 'black',
  blac: 'black',
  whit: 'white',
  whyte: 'white',
  bleu: 'blue',
  blu: 'blue',
  navey: 'navy',
  navvy: 'navy',
  gren: 'green',
  grene: 'green',
  yelow: 'yellow',
  yello: 'yellow',
  pnik: 'pink',
  pinl: 'pink',
  pinky: 'pink',
  purpel: 'purple',
  purpl: 'purple',
  perple: 'purple',
  orang: 'orange',
  ornage: 'orange',
  brwn: 'brown',
  borwn: 'brown',
  beig: 'beige',
  biege: 'beige',
  gery: 'grey',
  grry: 'grey',
  gray: 'grey',
  silvr: 'silver',
  goldn: 'gold',
  golden: 'gold',
  burgandy: 'burgundy',
  burgundi: 'burgundy',
  burgendy: 'burgundy',
  maron: 'maroon',
  marron: 'maroon',
  emrald: 'emerald',
  emerld: 'emerald',
  turqoise: 'turquoise',
  turquiose: 'turquoise',
  creme: 'cream',
  ivry: 'ivory',
  ivary: 'ivory',
  pich: 'peach',
  pech: 'peach',
  coral: 'coral',
  corral: 'coral',
  lavendar: 'lavender',
  lavander: 'lavender',
  lilc: 'lilac',
  lilak: 'lilac',
  mustad: 'mustard',
  musterd: 'mustard',
  khakhi: 'khaki',
  blsh: 'blush',
  blush: 'blush',
  champgne: 'champagne',
  champange: 'champagne',
  champaign: 'champagne',
  rosegold: 'rose gold',
  nud: 'nude',
  nued: 'nude',
  fushia: 'fuchsia',
  fuschia: 'fuchsia',
  fuschsia: 'fuchsia',
  teel: 'teal',
  tael: 'teal',
  mintt: 'mint',
  olve: 'olive',
  oliv: 'olive',
  taup: 'taupe',
  taupee: 'taupe',
  mauv: 'mauve',
  rust: 'rust',
  terracota: 'terracotta',
  terracotta: 'terracotta',

  // ===== Dresses (most-searched category) =====
  dres: 'dress',
  drss: 'dress',
  dreses: 'dresses',
  dresess: 'dresses',
  dreses: 'dresses',
  drees: 'dress',
  driess: 'dress',
  gwn: 'gown',
  gowne: 'gown',
  gawn: 'gown',
  maxy: 'maxi',
  maxxi: 'maxi',
  maxii: 'maxi',
  mini: 'mini',
  minni: 'mini',
  mid: 'midi',
  midi: 'midi',
  middi: 'midi',
  middy: 'midi',
  bodicon: 'bodycon',
  bodycn: 'bodycon',
  bodicone: 'bodycon',
  shft: 'shift',
  shifft: 'shift',
  wrapdress: 'wrap dress',
  rapdress: 'wrap dress',
  smok: 'smock',
  smokdress: 'smock dress',
  skater: 'skater',
  skter: 'skater',
  alineline: 'a-line',
  aline: 'a-line',
  empire: 'empire',
  empir: 'empire',
  sheth: 'sheath',
  sheeth: 'sheath',
  tier: 'tiered',
  teired: 'tiered',
  tiered: 'tiered',
  pleted: 'pleated',
  pleeted: 'pleated',

  // ===== Tops & blouses =====
  tshirt: 't-shirt',
  tshrt: 't-shirt',
  teeshirt: 't-shirt',
  blous: 'blouse',
  blowse: 'blouse',
  blose: 'blouse',
  blousee: 'blouse',
  swetar: 'sweater',
  sweather: 'sweater',
  swetter: 'sweater',
  jumpr: 'jumper',
  jumpper: 'jumper',
  hodie: 'hoodie',
  hoody: 'hoodie',
  hodi: 'hoodie',
  cardgan: 'cardigan',
  cardign: 'cardigan',
  cardigon: 'cardigan',
  shrt: 'shirt',
  shrits: 'shirts',
  tunc: 'tunic',
  tunik: 'tunic',
  camsole: 'camisole',
  camisol: 'camisole',
  cami: 'cami',
  tnk: 'tank',
  tnktop: 'tank top',
  bodysit: 'bodysuit',
  bodysuite: 'bodysuit',
  crpotop: 'crop top',
  croptop: 'crop top',
  cropptop: 'crop top',
  blzr: 'blazer',
  kimno: 'kimono',
  kimono: 'kimono',
  poncho: 'poncho',
  ponchu: 'poncho',
  shrug: 'shrug',
  bolero: 'bolero',

  // ===== Bottoms =====
  jens: 'jeans',
  jeens: 'jeans',
  jens: 'jeans',
  trowsers: 'trousers',
  trosers: 'trousers',
  trouser: 'trousers',
  pnts: 'pants',
  legings: 'leggings',
  legging: 'leggings',
  leggins: 'leggings',
  shrts: 'shorts',
  shortz: 'shorts',
  shortss: 'shorts',
  skrt: 'skirt',
  skirts: 'skirt',
  skrits: 'skirts',
  pencl: 'pencil',
  pencill: 'pencil',
  cullotes: 'culottes',
  culottes: 'culottes',
  cullote: 'culotte',
  joggrs: 'joggers',
  jogers: 'joggers',
  paperbag: 'paperbag',
  highwasted: 'high-waisted',
  highwaisted: 'high-waisted',

  // ===== Outerwear =====
  jaket: 'jacket',
  jacekt: 'jacket',
  jaccet: 'jacket',
  jakcet: 'jacket',
  coet: 'coat',
  cot: 'coat',
  coate: 'coat',
  blzer: 'blazer',
  blazr: 'blazer',
  blaser: 'blazer',
  parker: 'parka',
  treanch: 'trench',
  trnch: 'trench',
  pufer: 'puffer',
  puffr: 'puffer',
  bombr: 'bomber',
  bomer: 'bomber',
  fauxfur: 'faux fur',
  fauxleather: 'faux leather',
  trenchcoat: 'trench coat',
  capecoat: 'cape',
  cape: 'cape',

  // ===== Jumpsuits & co-ords =====
  jumpsut: 'jumpsuit',
  jumsuit: 'jumpsuit',
  jumpsuite: 'jumpsuit',
  jumsuite: 'jumpsuit',
  jupsuit: 'jumpsuit',
  playsut: 'playsuit',
  playsute: 'playsuit',
  playsiut: 'playsuit',
  romer: 'romper',
  rompr: 'romper',
  cordinates: 'co-ords',
  coords: 'co-ords',
  cords: 'co-ords',
  twopiece: 'two piece',
  twopice: 'two piece',
  matchingset: 'matching set',

  // ===== Lingerie & nightwear =====
  pyjma: 'pyjamas',
  pajama: 'pyjamas',
  pajamas: 'pyjamas',
  pyjamas: 'pyjamas',
  pyjma: 'pyjamas',
  nighty: 'nightie',
  nightie: 'nightie',
  nightdress: 'nightdress',
  nighgown: 'nightgown',
  robe: 'robe',
  dressinggown: 'dressing gown',
  lingere: 'lingerie',
  lingerei: 'lingerie',
  lingrie: 'lingerie',
  bralet: 'bralette',
  brallete: 'bralette',
  shapewear: 'shapewear',
  shapwear: 'shapewear',

  // ===== Swimwear =====
  swmsuit: 'swimsuit',
  swimsut: 'swimsuit',
  swimsuite: 'swimsuit',
  swimwer: 'swimwear',
  swimwere: 'swimwear',
  bikni: 'bikini',
  bikiny: 'bikini',
  bikkini: 'bikini',
  onepice: 'one-piece',
  onepiece: 'one-piece',
  beachwer: 'beachwear',
  beachware: 'beachwear',
  saron: 'sarong',
  sarrong: 'sarong',
  coverup: 'cover up',

  // ===== Occasions (huge for women's fashion) =====
  weding: 'wedding',
  weeding: 'wedding',
  weddng: 'wedding',
  weddin: 'wedding',
  bridsmaid: 'bridesmaid',
  bridemaid: 'bridesmaid',
  bridesmade: 'bridesmaid',
  bridsmaids: 'bridesmaids',
  motherofthebride: 'mother of the bride',
  motb: 'mother of the bride',
  pary: 'party',
  partey: 'party',
  partyy: 'party',
  evning: 'evening',
  eveing: 'evening',
  evenig: 'evening',
  evenining: 'evening',
  cocktial: 'cocktail',
  coktail: 'cocktail',
  cocktal: 'cocktail',
  coctail: 'cocktail',
  formel: 'formal',
  fromal: 'formal',
  formall: 'formal',
  casul: 'casual',
  casuel: 'casual',
  cassual: 'casual',
  prm: 'prom',
  promn: 'prom',
  proom: 'prom',
  graduaton: 'graduation',
  graduration: 'graduation',
  graduatiom: 'graduation',
  buisness: 'business',
  busness: 'business',
  bussiness: 'business',
  workwear: 'workwear',
  ofice: 'office',
  offce: 'office',
  offie: 'office',
  vacaton: 'vacation',
  vaction: 'vacation',
  vacasion: 'vacation',
  holday: 'holiday',
  holiady: 'holiday',
  holidy: 'holiday',
  cruse: 'cruise',
  cruize: 'cruise',
  birtday: 'birthday',
  birhday: 'birthday',
  birtday: 'birthday',
  anniversry: 'anniversary',
  anniverary: 'anniversary',
  anniverssary: 'anniversary',
  christmass: 'christmas',
  xmas: 'christmas',
  cristmas: 'christmas',
  newyear: 'new year',
  nyeve: 'new year',
  valentnes: 'valentines',
  valentine: 'valentines',
  valantines: 'valentines',
  halloweeen: 'halloween',
  haloween: 'halloween',
  ascot: 'ascot',
  raceday: 'race day',
  races: 'races',
  christning: 'christening',
  christeing: 'christening',
  babyshower: 'baby shower',
  henparty: 'hen party',
  hendo: 'hen do',
  engagment: 'engagement',
  engagemnt: 'engagement',
  galla: 'gala',
  balll: 'ball',

  // ===== Footwear =====
  shose: 'shoes',
  shooz: 'shoes',
  shoees: 'shoes',
  bots: 'boots',
  botes: 'boots',
  buts: 'boots',
  bootes: 'boots',
  ankleboot: 'ankle boots',
  kneehigh: 'knee high',
  sneakr: 'sneakers',
  sneeker: 'sneakers',
  sneakrs: 'sneakers',
  heals: 'heels',
  heeles: 'heels',
  hels: 'heels',
  stilleto: 'stiletto',
  stiletos: 'stilettos',
  stilletto: 'stiletto',
  sandls: 'sandals',
  sandels: 'sandals',
  sandls: 'sandals',
  flipflops: 'flip flops',
  flllats: 'flats',
  flatz: 'flats',
  ballerinas: 'ballet flats',
  balletflats: 'ballet flats',
  pums: 'pumps',
  pumbs: 'pumps',
  courtshoes: 'court shoes',
  wedge: 'wedges',
  wedgs: 'wedges',
  weges: 'wedges',
  trianers: 'trainers',
  triners: 'trainers',
  trainr: 'trainers',
  espadrils: 'espadrilles',
  espadrille: 'espadrilles',
  mules: 'mules',
  mulez: 'mules',
  slingbck: 'slingback',
  blockhel: 'block heel',
  kittenhel: 'kitten heel',

  // ===== Bags & accessories =====
  bg: 'bag',
  bagg: 'bag',
  handbg: 'handbag',
  handbeg: 'handbag',
  handabag: 'handbag',
  cluth: 'clutch',
  clutchh: 'clutch',
  cluch: 'clutch',
  purs: 'purse',
  purce: 'purse',
  walet: 'wallet',
  walett: 'wallet',
  totebag: 'tote bag',
  toat: 'tote',
  crossbody: 'crossbody',
  crosbody: 'crossbody',
  croosbody: 'crossbody',
  shoulderbag: 'shoulder bag',
  bckpack: 'backpack',
  bakpack: 'backpack',
  jewlery: 'jewellery',
  jewelry: 'jewellery',
  jewellry: 'jewellery',
  jewelary: 'jewellery',
  jewelery: 'jewellery',
  neclace: 'necklace',
  necklas: 'necklace',
  neckless: 'necklace',
  neckace: 'necklace',
  earing: 'earrings',
  earings: 'earrings',
  earrng: 'earrings',
  earrigns: 'earrings',
  hoops: 'hoops',
  hopes: 'hoops',
  studs: 'studs',
  braclet: 'bracelet',
  bracelat: 'bracelet',
  bracelt: 'bracelet',
  bangel: 'bangle',
  bangl: 'bangle',
  anklt: 'anklet',
  rngs: 'rings',
  bet: 'belt',
  belte: 'belt',
  scaf: 'scarf',
  scaff: 'scarf',
  scarves: 'scarves',
  hatt: 'hat',
  hatts: 'hats',
  fascintor: 'fascinator',
  fascinater: 'fascinator',
  fascinator: 'fascinator',
  headband: 'headband',
  hairband: 'hairband',
  hairclip: 'hair clip',
  sunglases: 'sunglasses',
  sunglassess: 'sunglasses',
  sunglas: 'sunglasses',
  sungalsses: 'sunglasses',
  glves: 'gloves',
  glovs: 'gloves',
  watche: 'watch',
  watchs: 'watches',
  tights: 'tights',
  tigths: 'tights',
  stockngs: 'stockings',
  socs: 'socks',

  // ===== Sizes & fit =====
  smal: 'small',
  smll: 'small',
  medum: 'medium',
  medim: 'medium',
  larg: 'large',
  lage: 'large',
  xtralarge: 'xl',
  exlarge: 'xl',
  pluss: 'plus',
  plussize: 'plus size',
  curvy: 'curve',
  curv: 'curve',
  petit: 'petite',
  petitte: 'petite',
  petitee: 'petite',
  petti: 'petite',
  talll: 'tall',
  ovrsized: 'oversized',
  oversize: 'oversized',
  slimfit: 'slim fit',
  regularfit: 'regular fit',
  loosefit: 'loose fit',
  relaxedfit: 'relaxed fit',
  maternty: 'maternity',
  maternty: 'maternity',
  maternaty: 'maternity',

  // ===== Materials & fabrics =====
  cottn: 'cotton',
  coton: 'cotton',
  cotn: 'cotton',
  silken: 'silk',
  silke: 'silk',
  silkk: 'silk',
  satn: 'satin',
  satine: 'satin',
  satine: 'satin',
  velvt: 'velvet',
  velevt: 'velvet',
  velvit: 'velvet',
  velour: 'velour',
  lether: 'leather',
  leathr: 'leather',
  leathar: 'leather',
  swede: 'suede',
  sued: 'suede',
  suedee: 'suede',
  denm: 'denim',
  denimm: 'denim',
  woll: 'wool',
  wol: 'wool',
  cashmre: 'cashmere',
  cashmer: 'cashmere',
  chifon: 'chiffon',
  chifffon: 'chiffon',
  chiffn: 'chiffon',
  shifon: 'chiffon',
  lac: 'lace',
  lacy: 'lace',
  laze: 'lace',
  linn: 'linen',
  linnen: 'linen',
  polyster: 'polyester',
  polester: 'polyester',
  sequn: 'sequin',
  sequen: 'sequin',
  sequins: 'sequin',
  sequine: 'sequin',
  sparkl: 'sparkle',
  sparkely: 'sparkly',
  glittr: 'glitter',
  gliter: 'glitter',
  metalic: 'metallic',
  matalic: 'metallic',
  tule: 'tulle',
  tull: 'tulle',
  organz: 'organza',
  organa: 'organza',
  mesh: 'mesh',
  jersy: 'jersey',
  jersee: 'jersey',
  knitt: 'knit',
  knited: 'knitted',
  ribed: 'ribbed',
  ribbedd: 'ribbed',
  crochet: 'crochet',
  crochett: 'crochet',
  faux: 'faux',
  fakefur: 'faux fur',

  // ===== Patterns & prints =====
  flowral: 'floral',
  flora: 'floral',
  florel: 'floral',
  florals: 'floral',
  stripd: 'striped',
  stripes: 'stripe',
  stripey: 'striped',
  checkrd: 'checked',
  chequered: 'checked',
  ploka: 'polka',
  polkadot: 'polka dot',
  paislay: 'paisley',
  paisly: 'paisley',
  paisely: 'paisley',
  animl: 'animal',
  animlprint: 'animal print',
  leopord: 'leopard',
  leperd: 'leopard',
  leperd: 'leopard',
  leoprd: 'leopard',
  zebr: 'zebra',
  zebraprint: 'zebra print',
  snak: 'snake',
  snakeskin: 'snakeskin',
  snakeprint: 'snake print',
  geometic: 'geometric',
  geometeric: 'geometric',
  tropcal: 'tropical',
  tropicl: 'tropical',
  abstrct: 'abstract',
  abstact: 'abstract',
  embroidred: 'embroidered',
  embroidary: 'embroidery',
  embroidered: 'embroidered',
  tiedye: 'tie dye',
  tiedie: 'tie dye',
  ombre: 'ombre',
  obmre: 'ombre',
  gingham: 'gingham',
  ginghm: 'gingham',
  houndstooh: 'houndstooth',
  tartn: 'tartan',
  tartin: 'tartan',
  plad: 'plaid',

  // ===== Necklines & details =====
  vneck: 'v-neck',
  veeneck: 'v-neck',
  scoopneck: 'scoop neck',
  squareneck: 'square neck',
  halterneck: 'halter neck',
  halter: 'halter',
  halternek: 'halter neck',
  offshoulder: 'off shoulder',
  ofshoulder: 'off shoulder',
  oneshoulder: 'one shoulder',
  cowlneck: 'cowl neck',
  turtlneck: 'turtle neck',
  turtleneck: 'turtle neck',
  highneck: 'high neck',
  sweethart: 'sweetheart',
  sweetheart: 'sweetheart',
  bardot: 'bardot',
  bardo: 'bardot',
  strapless: 'strapless',
  straples: 'strapless',
  spagettistrap: 'spaghetti strap',
  spaghettistrap: 'spaghetti strap',
  longsleve: 'long sleeve',
  longsleeve: 'long sleeve',
  shortsleve: 'short sleeve',
  capsleve: 'cap sleeve',
  pufsleeve: 'puff sleeve',
  puffsleve: 'puff sleeve',
  bellsleve: 'bell sleeve',
  flutersleeve: 'flutter sleeve',
  slevless: 'sleeveless',
  sleeveles: 'sleeveless',
  backless: 'backless',
  bakless: 'backless',
  cutout: 'cut out',
  cutouts: 'cut out',
  splt: 'split',
  splitleg: 'split leg',
  slit: 'slit',
  ruched: 'ruched',
  rouched: 'ruched',
  rufled: 'ruffled',
  rufle: 'ruffle',
  ruffel: 'ruffle',
  fringe: 'fringe',
  frnge: 'fringe',
  tassel: 'tassel',
  tasel: 'tassel',
  beded: 'beaded',
  beadedd: 'beaded',
  embelished: 'embellished',
  embelshed: 'embellished',
  embellish: 'embellished',

  // ===== Style descriptors =====
  vintge: 'vintage',
  vintag: 'vintage',
  vintange: 'vintage',
  bohmian: 'bohemian',
  boho: 'bohemian',
  bohemain: 'bohemian',
  elegnt: 'elegant',
  elagant: 'elegant',
  elegent: 'elegant',
  classic: 'classic',
  clasic: 'classic',
  classy: 'classy',
  clasy: 'classy',
  modrn: 'modern',
  modren: 'modern',
  trendi: 'trendy',
  trndy: 'trendy',
  trendyy: 'trendy',
  stylsh: 'stylish',
  stilish: 'stylish',
  glamours: 'glamorous',
  glamerous: 'glamorous',
  glamarous: 'glamorous',
  glam: 'glam',
  feminne: 'feminine',
  feminin: 'feminine',
  romatic: 'romantic',
  romntic: 'romantic',
  edgey: 'edgy',
  sxy: 'sexy',
  sexi: 'sexy',
  sophisticted: 'sophisticated',
  sophistcated: 'sophisticated',
  minimlist: 'minimalist',
  minimalst: 'minimalist',
  scandi: 'scandi',
  preppy: 'preppy',
  prepy: 'preppy',
  athleisre: 'athleisure',
  athleisure: 'athleisure',
  loungewer: 'loungewear',
  loungwear: 'loungewear',
  streetwer: 'streetwear',
  streatwear: 'streetwear',

  // ===== Brand & shopping terms =====
  ordr: 'order',
  ordder: 'order',
  delievery: 'delivery',
  delivry: 'delivery',
  deivery: 'delivery',
  retorn: 'return',
  retrn: 'return',
  reurn: 'return',
  refnd: 'refund',
  refnd: 'refund',
  refound: 'refund',
  exchnage: 'exchange',
  exhange: 'exchange',
  discont: 'discount',
  discunt: 'discount',
  voucer: 'voucher',
  voucher: 'voucher',
  promocde: 'promo code',
  cupon: 'coupon',
  coupn: 'coupon',
  sail: 'sale',
  sael: 'sale',
  clearnace: 'clearance',
  clearence: 'clearance',
  bestseler: 'bestseller',
  bestselers: 'bestsellers',
  newarrival: 'new arrivals',
  newarrivals: 'new arrivals',
  newin: 'new in',
};

/* ===============================
   SHARED: LOCAL SUGGESTIONS LOADER (single fetch, shared)
=============================== */
let publicLocalSuggestions = [];
const publicLocalSuggestionsReady = fetch(PUBLIC_SEARCH_CONFIG.SUGGESTION_URL)
  .then((r) => r.json())
  .then((data) => {
    publicLocalSuggestions = Array.isArray(data) ? data : [];
    console.log(`✅ [Public] Loaded ${publicLocalSuggestions.length} local suggestions`);
    return publicLocalSuggestions;
  })
  .catch((err) => {
    console.error('❌ [Public] Failed to load local suggestions:', err);
    publicLocalSuggestions = [];
    return [];
  });

/* ===============================
   SHARED: BEST SELLERS LOADER (cached fetch)
=============================== */
let publicBestSellersCache = null;
let publicBestSellersPromise = null;

function publicLoadBestSellers() {
  if (publicBestSellersCache) {
    console.log('🔁 [BestSellers] Returning cached:', publicBestSellersCache.products.length, 'products');
    return Promise.resolve(publicBestSellersCache);
  }
  if (publicBestSellersPromise) {
    console.log('⏳ [BestSellers] In-flight request, awaiting...');
    return publicBestSellersPromise;
  }

  console.log('📡 [BestSellers] Fetching:', PUBLIC_SEARCH_CONFIG.BEST_SELLERS_PATH);

  // Add a timeout so a hung request doesn't block the fallback UI forever
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 8000);

    publicBestSellersPromise = fetch(PUBLIC_SEARCH_CONFIG.BEST_SELLERS_PATH, {
    credentials: 'same-origin',
    signal: controller.signal,
    })
    .then((r) => {
      clearTimeout(timeoutId);
      console.log('📡 [BestSellers] Response status:', r.status, 'content-type:', r.headers.get('content-type'));

      // Distinguish 404 (collection/template missing) from other failures.
      // A 404 is a permanent config issue, not a transient error — cache the
      // empty result so we don't re-request on every zero-result search.
      if (r.status === 404) {
        const err = new Error('not_found');
        err.code = 'not_found';
        throw err;
      }
      if (!r.ok) throw new Error(`HTTP ${r.status}`);

      // Read as text first — Shopify view templates often return text/html
      // even when content is JSON. Parse manually so we don't lose the body.
      return r.text();
    })
    .then((rawText) => {
      let data;
      try {
        data = JSON.parse(rawText);
      } catch (parseErr) {
        console.error('❌ [BestSellers] Response is not valid JSON. First 200 chars:', rawText.substring(0, 200));
        const err = new Error('not_json');
        err.code = 'not_json';
        throw err;
      }

      const products = Array.isArray(data?.products) ? data.products : [];

      if (products.length === 0) {
        console.warn(
          '⚠️ [BestSellers] Collection returned 0 products. ' +
          'Check that the "best-sellers" collection exists and has products published to the Online Store sales channel.'
        );
      } else {
        console.log('✅ [BestSellers] Parsed', products.length, 'products from JSON');
      }

      const normalized = products
        .map((p) => {
          // Guard against malformed entries (missing handle = can't link → drop it)
          if (!p || !p.handle) return null;

          // Shopify prices are in pence — convert to pounds
          const priceInPounds = p.price != null ? Number(p.price) / 100 : 0;
          const comparePriceInPounds =
            p.compare_at_price != null ? Number(p.compare_at_price) / 100 : null;

          // Ensure image has protocol (Shopify returns //cdn.shopify.com/...)
          let imageUrl = p.image || '';
          if (imageUrl && imageUrl.startsWith('//')) {
            imageUrl = 'https:' + imageUrl;
          }

          return {
            handle: p.handle,
            name: p.title || '',
            image: imageUrl,
            price: priceInPounds,
            sale_price: comparePriceInPounds,
          };
        })
        .filter(Boolean);

      publicBestSellersCache = {
        collection: data?.collection || 'Best Sellers',
        products: normalized,
        // Flag so callers can distinguish "loaded but empty" from "failed to load"
        loadedSuccessfully: true,
      };
      return publicBestSellersCache;
    })
    .catch((err) => {
      clearTimeout(timeoutId);

      const code = err.code || (err.name === 'AbortError' ? 'timeout' : 'error');
      console.error(`❌ [BestSellers] Failed to load (${code}):`, err.message);

      const emptyResult = {
        collection: 'Best Sellers',
        products: [],
        loadedSuccessfully: false,
        errorCode: code,
      };

      // For 404 and not_json: cache the empty result permanently for this page
      // load — these are config issues that won't fix themselves on retry.
      // For timeout/network: clear the promise so the next zero-result search
      // can retry (transient failures may recover).
      if (code === 'not_found' || code === 'not_json') {
        publicBestSellersCache = emptyResult;
      } else {
        publicBestSellersPromise = null;
      }

      return emptyResult;
    });

  return publicBestSellersPromise;
}

/* ===============================
   SHARED: HELPERS
=============================== */
function publicEscapeHTML(text) {
  if (text == null) return '';
  return String(text).replace(/[&<>"]/g, (m) => {
    if (m === '&') return '&amp;';
    if (m === '<') return '&lt;';
    if (m === '>') return '&gt;';
    if (m === '"') return '&quot;';
    return m;
  });
}

function publicTokenize(value) {
  return value.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
}

function publicCorrectQuery(value) {
  const tokens = publicTokenize(value);
  const meaningful = tokens.filter((t) => !PUBLIC_SEARCH_STOPWORDS.includes(t));
  const corrected = meaningful.map((t) => PUBLIC_SEARCH_SYNONYMS[t] || t);
  return corrected.join(' ');
}




/* ===============================
   SHARED: PRICE QUERY FORMATTER
=============================== */
function publicFormatSearchDisplay(query) {

  if (!query) return { isPrice: false, displayText: '' };
  
  const trimmed = String(query).trim();
  
  // Case 1: Backend returned "price : 88976" format
  const priceRegex = /^price\s*:\s*(\d+(?:\.\d+)?)\s*$/i;
  const match = trimmed.match(priceRegex);
  if (match) {
    return {
      isPrice: true,
      priceValue: match[1],
      displayText: `Showing Search results for Prices under ${match[1]}`
    };
  }

  // Case 2: User typed a pure number (e.g. "88976") — treat as price query
  // Backend converts numeric-only queries to price searches
  if (/^\d+(?:\.\d+)?$/.test(trimmed)) {
    return {
      isPrice: true,
      priceValue: trimmed,
      displayText: `Showing Search results for Prices under ${trimmed}`
    };
  }
  
  return { isPrice: false, displayText: trimmed };
}

function publicMatchesInput(item, value) {
  const meaningfulTokens = publicTokenize(value).filter((t) => !PUBLIC_SEARCH_STOPWORDS.includes(t));
  if (meaningfulTokens.length === 0) return false;

  const textWords = publicTokenize(item.text);
  const keywords = (item.keywords || []).map((k) => k.toLowerCase());

  return meaningfulTokens.every(
    (token) =>
      textWords.some((w) => w === token || w.startsWith(token)) ||
      keywords.some((k) => k === token || k.startsWith(token))
  );
}

function publicComputeSuggestions(query, apiSuggestions = [], collectionsData = []) {
  const value = (query || '').trim().toLowerCase();
  if (!value || value.length < PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH) {
    return { localTexts: [], apiTexts: [], collectionItems: [] };
  }

  const correctedValue = publicCorrectQuery(value);

  let localExact = publicLocalSuggestions.filter(
    (item) =>
      item.text.toLowerCase() === correctedValue ||
      (item.keywords || []).map((k) => k.toLowerCase()).includes(correctedValue)
  );

  let localPartial = publicLocalSuggestions.filter(
    (item) => publicMatchesInput(item, correctedValue) && item.text.toLowerCase() !== correctedValue
  );

  const seenLocal = new Set(localExact.map((i) => i.id));
  localPartial = localPartial.filter((i) => !seenLocal.has(i.id));

  localExact.sort((a, b) => (a.priority || 0) - (b.priority || 0));
  localPartial.sort((a, b) => (a.priority || 0) - (b.priority || 0));

  let localResults = [...localExact, ...localPartial];

  let localFiltered = localResults.filter((r) => (r.priority || 0) <= 2);
  if (localFiltered.length === 0) {
    localFiltered = localResults.filter((r) => (r.priority || 0) === 3);
  }
  localResults = localFiltered;

  localResults = localResults.filter((item) => {
    if (!item.ignore_words || !Array.isArray(item.ignore_words)) return true;
    return !item.ignore_words.some((ig) => correctedValue === ig.toLowerCase());
  });

  const localTexts = [...new Set(localResults.map((item) => item.text))];

  const apiTexts =
    Array.isArray(apiSuggestions) && apiSuggestions.length > 0
      ? apiSuggestions.map((s) => (typeof s === 'string' ? s : s.text || s))
      : [];

  const collectionItems =
    Array.isArray(collectionsData) && collectionsData.length > 0 ? collectionsData.slice(0, 2) : [];

  return { localTexts, apiTexts, collectionItems };
}

function publicDedupeCollections(rawCollections) {
  if (!Array.isArray(rawCollections)) return [];
  const seen = new Set();
  return rawCollections.filter((c) => {
    const key = (c.title || '').toLowerCase();
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

function publicRenderSuggestionColumns(query, apiSuggestions, collectionsData, prefix) {
  const { localTexts, apiTexts, collectionItems } = publicComputeSuggestions(query, apiSuggestions, collectionsData);
  const hasLocal = localTexts.length > 0;
  const hasApi = apiTexts.length > 0;
  const hasCollections = collectionItems.length > 0;

  if (!hasLocal && !hasApi && !hasCollections) return '';

  const renderTextColumn = (title, items) => `
    <div class="${prefix}-column">
      <div class="${prefix}-column-title">${title}</div>
      <div class="${prefix}-suggestions-group">
        ${items
          .map(
            (text) => `
          <span class="${prefix}-suggestion-text" data-value="${publicEscapeHTML(text)}">
            ${publicEscapeHTML(text)}
          </span>
        `
          )
          .join('')}
      </div>
    </div>
  `;

  const renderCollectionColumn = (items) => `
    <div class="${prefix}-column">
      <div class="${prefix}-column-title">Related Categories</div>
      <div class="${prefix}-suggestions-group">
        ${items
          .map(
            (collection) => `
          <a href="/collections/${collection.handle}"
             class="${prefix}-collection-link"
             data-handle="${collection.handle}">
            ${publicEscapeHTML(collection.title)}
            <span class="${prefix}-collection-arrow">→</span>
          </a>
        `
          )
          .join('')}
      </div>
    </div>
  `;

  return `
    <div class="${prefix}-columns-container">
      ${hasLocal ? renderTextColumn('Popular Suggestions', localTexts) : ''}
      ${hasApi ? renderTextColumn('Alternative Suggestions', apiTexts) : ''}
      ${hasCollections ? renderCollectionColumn(collectionItems) : ''}
    </div>
  `;
}

function publicGoToSearchResults(query) {
  // ⛔ Reject queries that don't meet the minimum length
  if (!query || query.trim().length < PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH) {
    return;  // No navigation for short queries
  }

  try {
    localStorage.setItem('public_ai_search_query', query.trim());
  } catch (e) {
    // best effort
  }
  window.location.href = `${PUBLIC_SEARCH_CONFIG.RESULTS_PAGE_PATH}?q=${encodeURIComponent(query.trim())}`;
}



/* ============================================================
   PART 1: DROPDOWN
============================================================ */
(function () {
  const desktopInput = document.getElementById('Search-In-Modal-Single');
  const mobileInput = document.querySelector('.search-for-mobile-input');
  if (!desktopInput && !mobileInput) return;

  /* ---------- State ---------- */
  let abortController = new AbortController();
  let lastQuery = '';
  let lastApiQuery = ''; 
  let lastTotal = 0;
  let cachedWidth = null;
  let currentLeftHTML = '';
  let currentRightHTML = '';
  let currentActiveInput = null;
  let isDropdownVisible = false;

  let apiSuggestions = [];
  let collectionsData = [];
  let apiReturnedQuery = '';

  let suggestionsLoading = false;

  let navigableItems = [];
  let highlightedIndex = -1;

  function removeSnizeIfExists() {
    const el = document.getElementById('snize-instant-search-results');
    if (el) el.remove();
  }

  function setupInputAria(inputElement) {
    if (!inputElement) return;
    inputElement.setAttribute('role', 'combobox');
    inputElement.setAttribute('aria-autocomplete', 'list');
    inputElement.setAttribute('aria-expanded', 'false');
    inputElement.setAttribute('aria-controls', 'public-ai-search-dropdown');
    inputElement.setAttribute('aria-haspopup', 'listbox');
  }
  setupInputAria(desktopInput);
  setupInputAria(mobileInput);


  /* ---------- Dropdown element ---------- */
  const dropdown = document.createElement('div');
  dropdown.id = 'public-ai-search-dropdown';
  Object.assign(dropdown.style, {
    position: 'fixed',
    zIndex: '101',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.05)',
    display: 'none',
    maxHeight: '95vh',
    overflow: 'hidden',
    transform: 'translateZ(0)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    backgroundColor: 'rgba(255, 255, 255, 0.96)',
    maxWidth: '1920px',
    width: '90%',
  });
  document.body.appendChild(dropdown);
  dropdown.setAttribute('role', 'listbox');
  dropdown.setAttribute('aria-label', 'Search suggestions and results');

  // ⭐ A11Y: live region for screen reader announcements
    const liveRegion = document.createElement('div');
    liveRegion.id = 'public-ai-search-live-region';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.setAttribute('role', 'status');
    Object.assign(liveRegion.style, {
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: '0',
      margin: '-1px',
      overflow: 'hidden',
      clip: 'rect(0,0,0,0)',
      whiteSpace: 'nowrap',
      border: '0',
    });
    document.body.appendChild(liveRegion);

    function announce(message) {
      if (!liveRegion) return;
      // Clear then set — forces screen reader to re-announce even if text is similar
      liveRegion.textContent = '';
      setTimeout(() => { liveRegion.textContent = message; }, 50);
    }

  /* ---------- Position ---------- */
  function positionDropdown(inputElement) {
    if (!inputElement) return;

    const rect = inputElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    if (!cachedWidth) cachedWidth = rect.width;

    const spaceBelow = viewportHeight - rect.bottom;
    const spaceAbove = rect.top;
    const dropdownHeight = 600;

    const topPosition =
      spaceBelow >= dropdownHeight || spaceBelow > spaceAbove
        ? rect.bottom + 8
        : rect.top - dropdownHeight - 8;

    const left = (viewportWidth - viewportWidth * 0.9) / 2;
    dropdown.style.top = topPosition + 'px';
    dropdown.style.left = left + 'px';
    dropdown.style.width = '90%';
    dropdown.style.maxWidth = '1920px';

    if (viewportWidth < 768) {
      dropdown.style.width = 'calc(100vw - 32px)';
      dropdown.style.left = '16px';
      dropdown.style.maxWidth = 'calc(100vw - 32px)';
    }
  }

  window.addEventListener('resize', () => {
    cachedWidth = null;
    if (isDropdownVisible && currentActiveInput) positionDropdown(currentActiveInput);
  });

  window.addEventListener(
    'scroll',
    () => {
      if (isDropdownVisible && currentActiveInput) positionDropdown(currentActiveInput);
    },
    { passive: true }
  );


/* ---------- CLICK OUTSIDE TO CLOSE ---------- */
  document.addEventListener('click', (e) => {
    if (!isDropdownVisible) return;

    // Click inside the dropdown itself — ignore
    if (dropdown.contains(e.target)) return;

    // Click on either search input — ignore (focus/click handlers reopen it)
    if (desktopInput && desktopInput.contains(e.target)) return;
    if (mobileInput && mobileInput.contains(e.target)) return;

    // Click on the search form wrapper / icon — ignore
    if (e.target.closest('form[role="search"]')) return;

    // Otherwise — close (input text preserved)
    hideDropdown();
  }, true);

  /* ---------- ESCAPE KEY TO CLOSE (GLOBAL) ---------- */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isDropdownVisible) {
      dismissDropdown();
    }
  });

  /* ---------- Render fragments ---------- */
  function closeButtonHTML() {
    return `
      <button class="public-ai-search-dropdown-close-btn" aria-label="Close suggestions">
        <svg class="public-ai-search-close-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="public-ai-search-close-icon-path" d="M18 6L6 18M6 6L18 18"/>
        </svg>
      </button>
    `;
  }

  function suggestionSkeletonHTML() {
    return `
      <div class="public-ai-search-suggestion-container">
        <div class="public-ai-search-suggestion-header">${closeButtonHTML()}</div>
        <div class="public-ai-search-suggestions-list">
          ${Array.from({ length: 4 })
            .map(
              () =>
                `<span class="public-ai-search-skeleton-item"> </span><span class="public-ai-search-separator">|</span>`
            )
            .join('')}
          <span class="public-ai-search-skeleton-item"> </span>
        </div>
      </div>
    `;
  }

  function renderSuggestions(query) {
    if (suggestionsLoading && query.length >= PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH) {
      return suggestionSkeletonHTML();
    }

    if (!query || query.trim().length < PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH) return '';

    const columnsHTML = publicRenderSuggestionColumns(
      query,
      apiSuggestions,
      collectionsData,
      'public-ai-search'
    );

    if (!columnsHTML) {
      return `
        <div class="public-ai-search-suggestion-container">
          <div class="public-ai-search-suggestion-header">${closeButtonHTML()}</div>
          <div class="public-ai-search-empty-state">
            <span>✨</span><span>No suggestions found</span>
          </div>
        </div>
      `;
    }

    return `
      <div class="public-ai-search-suggestion-container">
        <div class="public-ai-search-suggestion-header">${closeButtonHTML()}</div>
        ${columnsHTML}
      </div>
    `;
  }

  function productSkeleton() {
    return `
      <div class="ai-products-grid public-ai-search-products-grid">
        ${Array.from({ length: 6 })
          .map(
            () => `
          <div class="ai-product-card public-ai-search-product-card">
            <div class="public-ai-search-image-skeleton"> </div>
            <div class="public-ai-search-content-skeleton">
              <div class="public-ai-search-title-skeleton"> </div>
              <div class="public-ai-search-price-skeleton"> </div>
            </div>
          </div>
        `
          )
          .join('')}
      </div>
      <div class="public-ai-search-loading-container">
        <span class="public-ai-spinner-modern"> </span>
        <div class="public-ai-search-loading-text">Loading products...</div>
      </div>
    `;
  }

  const STATE_MESSAGES = {
    network: { icon: '⚠️', title: 'Under Maintenance', subtitle: 'Please check after some time.' },
    forbidden: { icon: '🔒', title: 'Access Restricted', subtitle: 'Unable to fetch products at this time' },
    auth: { icon: '🔑', title: 'Authentication Failed', subtitle: 'Please refresh the page and try again' },
  };

  function renderErrorMessage(errorType = 'network') {
    const msg = STATE_MESSAGES[errorType] || STATE_MESSAGES.network;
    return `
      <div class="public-ai-search-error-container">
        <div class="public-ai-search-error-content">
          <div>
            <div class="public-ai-search-error-icon">${msg.icon}</div>
            <div class="public-ai-search-error-title">${msg.title}</div>
            <div class="public-ai-search-error-subtitle">${msg.subtitle}</div>
          </div>
        </div>
      </div>
    `;
  }

  // ⭐ NEW: render best-sellers fallback when zero results
  function renderBestSellersFallback(bestSellers, query) {
    const products = (bestSellers?.products || []).slice(0, 12);
    if (!products.length) {
      // Best sellers also unavailable — fall back to plain "no products" message
      return renderNoProductsMessage();
    }

    return `
      <div class="public-ai-search-empty-state-container">
        <div>
          <div class="public-ai-search-empty-title">No products found</div>
          <div class="public-ai-search-empty-subtitle">Try adjusting your search terms</div>
        </div>
      </div>

      <div class="public-ai-search-no-results-banner" style="margin: 24px 0 12px; padding: 0 16px;">
        <div style="font-size: 16px; font-weight: 600; color: #111827;">
          You might like these — our best sellers
        </div>
        <div style="font-size: 13px; color: #6b7280; margin-top: 4px;">
          Hand-picked favourites from our customers
        </div>
      </div>
      <div class="ai-products-grid">
        ${products.map(renderProductCard).join('')}
      </div>
      ${renderRefinementSection()}
    `;
  }

  function renderNoProductsMessage() {
    setHeight('', '');
    return `
      <div class="public-ai-search-empty-state-container">
        <div>
          <div class="public-ai-search-empty-title">No products found</div>
          <div class="public-ai-search-empty-subtitle">Try adjusting your search terms</div>
        </div>
      </div>
    `;
  }

  function renderTypeMoreMessage() {
    return `
      <div style="padding: 30px 16px; text-align: center; color: #9ca3af;">
        <div style="font-size: 12px; color: #ff0000; margin-bottom: 4px;display:none">
          Our AI-powered system tailors results to your preferences and past activity to help you find what you're looking for faster.
        </div>
        <div style="font-size: 12px; font-weight: 500; margin-bottom: 4px; color: #374151;">
          Type at least ${PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH} characters
        </div>
        <div style="font-size: 12px; color: #9ca3af;">Keep typing to search for products</div>
      </div>
    `;
  }

  function renderProductCard(item) {
    const regularPrice = item.price ?? 0;
    const salePrice = item.sale_price;
    const hasSale = salePrice && Number(salePrice) !== Number(regularPrice);

    const priceHTML = hasSale
      ? `
        <s class="price-item strike price-item--regular">
          <span class="money">£${Number(regularPrice).toFixed(2)}</span>
        </s>
        <span class="price-item price-item--sale">
          <span class="money">£${Number(salePrice).toFixed(2)}</span>
        </span>
      `
      : `
        <span class="price-item price-item--regular">
          <span class="money">£${Number(regularPrice).toFixed(2)}</span>
        </span>
      `;

    return `
      <a href="/products/${item.handle}"
         class="ai-product-card"
         style="display:block;text-decoration:none;color:inherit;">
        <div style="overflow: hidden; position: relative;">
          <img src="${item.image || ''}"
               alt="${publicEscapeHTML(item.name || '')}"
               style="width: 100%; height: 100%; object-fit: cover;"
               loading="lazy" />
        </div>
        <div class="public-ai-search-product-info">
          <div class="public-ai-search-product-name">${publicEscapeHTML(item.name || '')}</div>
          <div class="public-ai-search-price-wrapper">${priceHTML}</div>
        </div>
      </a>
    `;
  }

  function renderRefinementSection() {
    const userId = (() => {
      try {
        return localStorage.getItem('user_id');
      } catch (e) {
        return null;
      }
    })();

    // Hide "Recommended for You" for unregistered users — it implies personalization
    const chips = userId
      ? ['New Arrivals', 'Best Sellers', 'On Sale', 'Under £100', 'Recommended for You']
      : ['New Arrivals', 'Best Sellers', 'On Sale', 'Under £100'];

    return `
      <div class="public-ai-search-refinement-section">
        <div class="public-ai-search-refinement-content">
          <div>
            <div class="public-ai-search-refinement-title">Refine with AI</div>
            <div class="public-ai-search-refinement-subtitle">
              Refine your search using popular shopping preferences to quickly find styles that suit you best.
            </div>
            <div class="public-ai-search-refinement-chips">
              ${chips
                .map(
                  (label) =>
                    `<button class="public-ai-search-refinement-chip" data-refinement="${label}" data-message="${label}">${label}</button>`
                )
                .join('')}
            </div>
          </div>
          <div class="public-ai-search-chat-prompt" data-refinement="show me occasion" data-message="show me occasion">
            <div class="public-ai-search-chat-content">
              <span class="public-ai-search-chat-icon">💬</span>
              <div class="public-ai-search-chat-text">Choose your occasion</div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  /* ---------- Layout ---------- */
  function setHeight(dropdownHeight, layoutMaxHeight) {
    requestAnimationFrame(() => {
      const dropdownEl = document.querySelector('#public-ai-search-dropdown');
      const layoutContainerEl = document.querySelector('.public-ai-search-layout-container');
      if (dropdownEl) dropdownEl.style.height = dropdownHeight;
      if (layoutContainerEl) layoutContainerEl.style.maxHeight = layoutMaxHeight;
    });
  }

  function renderLayout(suggestionsHTML, productsHTML, showCloseOnly = false) {
    currentLeftHTML = suggestionsHTML || renderSuggestions('');
    currentRightHTML = productsHTML || '';

    const currentQueryLength = currentActiveInput ? currentActiveInput.value.trim().length : 0;
    const showCloseInHeader = showCloseOnly || currentQueryLength < PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH;

    dropdown.innerHTML = `
      <div class="public-ai-search-layout-container">
        <div class="public-ai-search-sticky-header public-ai-search-suggestions-wrapper">
          ${currentLeftHTML}
          <div class="public-ai-search-products-header">
            <div class="public-ai-search-products-title">Products</div>
            ${showCloseInHeader ? closeButtonHTML() : ''}
            <div class="public-ai-search-header-search-term"></div>
            <div id="public-ai-search-header-view-all" class="public-ai-search-header-view-all"></div>
          </div>
        </div>
        <div class="public-ai-search-products-section">${currentRightHTML}</div>
      </div>
    `;

    if (currentActiveInput) positionDropdown(currentActiveInput);
    dropdown.style.display = 'flex';
    isDropdownVisible = true;
    if (currentActiveInput) currentActiveInput.setAttribute('aria-expanded', 'true');
    rebuildNavigableItems();
  }

  function updateSearchTermAndViewAll(query, total) {
    requestAnimationFrame(() => {
      const searchTermDiv = document.querySelector('.public-ai-search-header-search-term');
       if (searchTermDiv) {
        searchTermDiv.style.display = 'block';
        
        if (total === 0) {
          searchTermDiv.innerHTML = '';
        } else {
          // Check the API-returned query first (it knows about price transforms)
          const priceInfo = publicFormatSearchDisplay(lastApiQuery || query);
          if (priceInfo.isPrice) {
            searchTermDiv.innerHTML = `Showing Search results for Prices under <span class="public-ai-search-search-term-highlight">${publicEscapeHTML(priceInfo.priceValue)}</span>`;
          } else {
              searchTermDiv.innerHTML =
                `Showing Search Result(s) for - <span class="public-ai-search-search-term-highlight">${publicEscapeHTML(query)}</span>`;
            }
        }
      }

      const viewAllUrl = `${PUBLIC_SEARCH_CONFIG.RESULTS_PAGE_PATH}?q=${encodeURIComponent(query)}`;

      const topViewAllContainer = document.getElementById('public-ai-search-header-view-all');
      if (topViewAllContainer) {
        topViewAllContainer.innerHTML =
          total > 12
            ? `
              <a href="${viewAllUrl}" class="public-ai-search-view-all-link">
                View All Products (${total})
                <span class="public-ai-search-view-all-arrow">→</span>
              </a>
            `
            : '';
      }

      const bottomViewAllContainer = document.getElementById('public-ai-search-bottom-view-all');
      if (bottomViewAllContainer) {
        if (total > 12) {
          bottomViewAllContainer.style.display = 'block';
          const bottomLink = bottomViewAllContainer.querySelector('.public-ai-search-bottom-view-all-link');
          if (bottomLink) {
            bottomLink.href = viewAllUrl;
            bottomLink.innerHTML = `View All Products (${total}) <span class="public-ai-search-view-all-arrow">→</span>`;
          }
        } else {
          bottomViewAllContainer.style.display = 'none';
        }
      }
      rebuildNavigableItems(); 
    });
    
  }



  function showExistingResults() {
    if (currentLeftHTML && currentRightHTML) {
      renderLayout(currentLeftHTML, currentRightHTML);
      updateSearchTermAndViewAll(lastQuery, lastTotal);
      announce(`${lastTotal} product${lastTotal === 1 ? '' : 's'} found for ${lastQuery}`); // ⭐ A11Y
      if (lastTotal > 1) setHeight('80%', '95vh');
    } else {
      dropdown.style.display = 'flex';
      isDropdownVisible = true;
    }
  }

  function hideDropdown() {
    dropdown.style.display = 'none';
    isDropdownVisible = false;
    if (currentActiveInput) {
      currentActiveInput.setAttribute('aria-expanded', 'false');
      currentActiveInput.removeAttribute('aria-activedescendant');
    }
    clearHighlight();
  }
  /* ---------- Keyboard navigation ---------- */
  function rebuildNavigableItems() {
    const selectors = [
      '.public-ai-search-dropdown-close-btn',
      '.public-ai-search-suggestion-text',
      '.public-ai-search-collection-link',
      '.public-ai-search-header-view-all',
      '.public-ai-search-view-all-link',
      '.ai-product-card',
      '.public-ai-search-bottom-view-all-link',
      '.public-ai-search-refinement-chip',
      '.public-ai-search-chat-prompt'
    ];

    navigableItems = [];
    selectors.forEach((sel) => {
      dropdown.querySelectorAll(sel).forEach((el) => {
        navigableItems.push(el);
      });
    });

    navigableItems.forEach((el, i) => {
      if (!el.id) el.id = `public-ai-search-item-${i}`;
      el.setAttribute('role', 'option');
      el.setAttribute('aria-selected', 'false');
    });

    highlightedIndex = -1;
  }

  function setHighlight(newIndex) {
    if (highlightedIndex >= 0 && navigableItems[highlightedIndex]) {
      navigableItems[highlightedIndex].classList.remove('public-ai-search-highlighted');
      navigableItems[highlightedIndex].setAttribute('aria-selected', 'false');
    }

    highlightedIndex = newIndex;

    if (highlightedIndex < 0 || !navigableItems[highlightedIndex]) {
      if (currentActiveInput) currentActiveInput.removeAttribute('aria-activedescendant');
      return;
    }

    const el = navigableItems[highlightedIndex];
    el.classList.add('public-ai-search-highlighted');
    el.setAttribute('aria-selected', 'true');

    if (currentActiveInput) {
      currentActiveInput.setAttribute('aria-activedescendant', el.id);
    }

    el.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
  function findHorizontalNeighbor(fromIndex, direction) {
    const current = navigableItems[fromIndex];
    if (!current) return -1;

    const currentRect = current.getBoundingClientRect();
    const currentCenterY = currentRect.top + currentRect.height / 2;
    const rowTolerance = currentRect.height * 0.5; // items overlapping vertically = same row

    let best = -1;
    let bestDistance = Infinity;

    for (let i = 0; i < navigableItems.length; i++) {
      if (i === fromIndex) continue;
      const rect = navigableItems[i].getBoundingClientRect();
      const centerY = rect.top + rect.height / 2;

      // Same row?
      if (Math.abs(centerY - currentCenterY) > rowTolerance) continue;

      // Correct side?
      const horizontalDelta = rect.left - currentRect.left;
      if (direction === 1 && horizontalDelta <= 0) continue;
      if (direction === -1 && horizontalDelta >= 0) continue;

      const distance = Math.abs(horizontalDelta);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = i;
      }
    }

    return best;
  }

  function clearHighlight() {
    if (highlightedIndex >= 0 && navigableItems[highlightedIndex]) {
      navigableItems[highlightedIndex].classList.remove('public-ai-search-highlighted');
      navigableItems[highlightedIndex].setAttribute('aria-selected', 'false');
    }
    highlightedIndex = -1;
    if (currentActiveInput) currentActiveInput.removeAttribute('aria-activedescendant');
  }

  /* ---------- Fetch products ---------- */
  function fetchProducts(query) {
    if (query.length < PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH) return;
    lastQuery = query;

    publicSearchAuthFetch(PUBLIC_SEARCH_CONFIG.SEARCH_URL, {
      method: 'POST',
      signal: abortController.signal,
      body: JSON.stringify({ query }),
    })
      .then((r) => {
        if (!r) throw new Error('auth');
        if (!r.ok) {
          if (r.status === 403) throw new Error('forbidden');
          throw new Error('network');
        }
        return r.json();
      })
      .then((data) => {
        if (query !== lastQuery) return;
        dropdown.removeAttribute('aria-busy');

        apiSuggestions = Array.isArray(data.suggestions)
          ? data.suggestions.map((text) => ({ text }))
          : [];
        collectionsData = publicDedupeCollections(data.collections);
        lastTotal = data.total || 0;
        suggestionsLoading = false;
        lastApiQuery = data.query || query; 

        const items = data?.items?.flat() || [];

        if (!items.length) {
          // ⭐ Zero results — show best sellers as fallback
          console.log('🚫 [Dropdown] Zero results for "' + query + '", loading best sellers fallback');
          publicLoadBestSellers().then((bestSellers) => {
            if (query !== lastQuery) return;
            console.log('🎯 [Dropdown] Rendering fallback with', bestSellers.products.length, 'best sellers');
            renderLayout(
              renderSuggestions(query),
              renderBestSellersFallback(bestSellers, query),
              false
            );
            setHeight('80%', '95vh');
            // Clear the "X results" search term display since we're showing best sellers
            requestAnimationFrame(() => {
              const searchTermDiv = document.querySelector('.public-ai-search-header-search-term');
              if (searchTermDiv) {
                searchTermDiv.style.display = 'none';
                searchTermDiv.innerHTML = '';
              }
              const viewAllContainer = document.getElementById('public-ai-search-header-view-all');
              if (viewAllContainer) viewAllContainer.innerHTML = '';
            });
            announce(`No products found for ${query}. Showing best sellers instead.`); // ⭐ A11Y
          });
          return;
        }

        const productsHTML = `
          <div class="ai-products-grid">
            ${items.slice(0, 12).map(renderProductCard).join('')}
          </div>
          <div id="public-ai-search-bottom-view-all" class="public-ai-search-bottom-view-all">
            <a href="#" class="public-ai-search-bottom-view-all-link">
              View All Products
              <span class="public-ai-search-view-all-arrow">→</span>
            </a>
          </div>
          ${renderRefinementSection()}
        `;

        renderLayout(renderSuggestions(query), productsHTML, false);
        setHeight('80%', '95vh');
        updateSearchTermAndViewAll(query, lastTotal);
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        if (query !== lastQuery) return;
        dropdown.removeAttribute('aria-busy');

        // Reset loading flag in error path so subsequent searches recover
        suggestionsLoading = false;

        const errorType = ['forbidden', 'auth'].includes(error.message) ? error.message : 'network';
        renderLayout(renderSuggestions(query), renderErrorMessage(errorType), false);
        announce('Error loading search results. Please try again.'); 

        requestAnimationFrame(() => {
          const searchTermDiv = document.querySelector('.public-ai-search-header-search-term');
          if (searchTermDiv) {
            searchTermDiv.style.display = 'none';
            searchTermDiv.innerHTML = '';
          }
        });
      });
  }

  /* ---------- Debounce ---------- */
  function debounce(fn, delay = 500) {
    let timer;
    function debounced(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    }
    debounced.cancel = () => clearTimeout(timer);
    return debounced;
  }

  const debouncedFetchProducts = debounce((query) => {
    if (query.length < PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH) return;
    abortController.abort();
    abortController = new AbortController();
    fetchProducts(query);
  }, 600);

  /* ---------- Input change ---------- */
  function clearViewAllUI() {
    requestAnimationFrame(() => {
      const searchTermDiv = document.querySelector('.public-ai-search-header-search-term');
      if (searchTermDiv) {
        searchTermDiv.style.display = 'none';
        searchTermDiv.innerHTML = '';
      }
      const viewAllContainer = document.getElementById('public-ai-search-header-view-all');
      if (viewAllContainer) viewAllContainer.innerHTML = '';
      const bottomViewAllContainer = document.getElementById('public-ai-search-bottom-view-all');
      if (bottomViewAllContainer) bottomViewAllContainer.style.display = 'none';
    });
  }

  function handleInputChange(inputElement, value, immediate = false) {
     removeSnizeIfExists();
     clearHighlight();
    if (value.length <= 0) {
      debouncedFetchProducts.cancel();
      abortController.abort();
      hideDropdown();
      lastQuery = '';
      lastTotal = 0;
      currentLeftHTML = '';
      currentRightHTML = '';
      return;
    }

    if (value.length < PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH) {
      debouncedFetchProducts.cancel();
      abortController.abort();
      suggestionsLoading = false;
      renderLayout('', renderTypeMoreMessage(), true);
      setHeight('', '');
      clearViewAllUI();
      return;
    }

    suggestionsLoading = true;
    dropdown.setAttribute('aria-busy', 'true'); // ⭐ A11Y
    renderLayout(suggestionSkeletonHTML(), productSkeleton(), false);
    setHeight('', '');
    clearViewAllUI();

    if (immediate) {
      debouncedFetchProducts.cancel();
      abortController.abort();
      abortController = new AbortController();
      fetchProducts(value);
    } else {
      debouncedFetchProducts(value);
    }
  }

  /* ---------- Input handlers ---------- */
  function setupInputHandlers(inputElement) {
    if (!inputElement) return;

    inputElement.addEventListener('input', () => {
       removeSnizeIfExists();
      currentActiveInput = inputElement;
      handleInputChange(inputElement, inputElement.value.trim());
    });

    inputElement.addEventListener('focus', () => {
       removeSnizeIfExists();
      currentActiveInput = inputElement;
      const value = inputElement.value.trim();
      positionDropdown(inputElement);

      if (!value || value.length < PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH) {
        renderLayout('', renderTypeMoreMessage(), true);
        return;
      }

      if (value === lastQuery) {
        showExistingResults();
      } else {
        handleInputChange(inputElement, value, true);
      }
    });

 
    inputElement.addEventListener('click', () => {
      if (isDropdownVisible) return; // already open
      removeSnizeIfExists();
      const value = inputElement.value.trim();
      if (!value) return;
      currentActiveInput = inputElement;

      if (value === lastQuery) {
        showExistingResults();
      } else if (value.length >= PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH) {
        handleInputChange(inputElement, value, true);
      } else {
        renderLayout('', renderTypeMoreMessage(), true);
      }
    });


    inputElement.addEventListener('keydown', (e) => {
      removeSnizeIfExists();
      const value = inputElement.value.trim();

      if (e.key === 'Enter') {
        // If a dropdown item is highlighted, activate it
        if (isDropdownVisible && highlightedIndex >= 0 && navigableItems[highlightedIndex]) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          navigableItems[highlightedIndex].click();
          return;
        }
        // Otherwise, submit the query as before
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (value.length < PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH) {
          return;
        }
        publicGoToSearchResults(value);
        return;
      }

      if (!isDropdownVisible) return;

      if (e.key === 'Escape') {
        e.preventDefault();
        dismissDropdown();
        return;
      }

      if (e.key === 'Tab' && !e.shiftKey) {
        if (navigableItems.length === 0) return; // nothing to highlight, let Tab do its normal thing

        e.preventDefault();

        // No item highlighted yet → start at first
        if (highlightedIndex < 0) {
          setHighlight(0);
          return;
        }

        // Wrap from last back to first
        const next = highlightedIndex < navigableItems.length - 1 ? highlightedIndex + 1 : 0;
        setHighlight(next);
        return;
      }

      if (e.key === 'Tab' && e.shiftKey) {
        if (navigableItems.length === 0) return;

        e.preventDefault();

        // No item highlighted yet → start at last
        if (highlightedIndex < 0) {
          setHighlight(navigableItems.length - 1);
          return;
        }

        // Wrap from first back to last
        const prev = highlightedIndex > 0 ? highlightedIndex - 1 : navigableItems.length - 1;
        setHighlight(prev);
        return;
      }
      
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (navigableItems.length === 0) return;
        const next = highlightedIndex < navigableItems.length - 1 ? highlightedIndex + 1 : 0;
        setHighlight(next);
        return;
      }

      if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (navigableItems.length === 0) return;
        const prev = highlightedIndex > 0 ? highlightedIndex - 1 : navigableItems.length - 1;
        setHighlight(prev);
        return;
      }
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        // Only intercept arrow keys when a dropdown item is highlighted.
        // Otherwise let the browser handle caret movement in the input.
        if (highlightedIndex < 0 || navigableItems.length === 0) return;

        e.preventDefault();
        const direction = e.key === 'ArrowRight' ? 1 : -1;
        const target = findHorizontalNeighbor(highlightedIndex, direction);
        if (target !== -1) setHighlight(target);
        return;
      }

      if (e.key === 'Home' && navigableItems.length > 0) {
        e.preventDefault();
        setHighlight(0);
        return;
      }

      if (e.key === 'End' && navigableItems.length > 0) {
        e.preventDefault();
        setHighlight(navigableItems.length - 1);
        return;
      }

    }, true);

  }

  setupInputHandlers(desktopInput);
  setupInputHandlers(mobileInput);


  function dismissDropdown() {
      const scrollY = window.scrollY;

      if (window.location.pathname.includes(PUBLIC_SEARCH_CONFIG.RESULTS_PAGE_PATH)) {
        const urlQuery = new URLSearchParams(window.location.search).get('q') || '';
        if (desktopInput) desktopInput.value = urlQuery;
        if (mobileInput) mobileInput.value = urlQuery;
        lastQuery = '';
        lastTotal = 0;
        currentLeftHTML = '';
        currentRightHTML = '';
        debouncedFetchProducts.cancel();
        abortController.abort();
      }

      hideDropdown();
      if (currentActiveInput) currentActiveInput.blur();
      requestAnimationFrame(() => window.scrollTo(0, scrollY));
      setTimeout(() => window.scrollTo(0, scrollY), 100);
    }

  /* ---------- Dropdown click delegation ---------- */
  dropdown.addEventListener('click', (e) => {
   if (e.target.closest('.public-ai-search-dropdown-close-btn')) {
       e.preventDefault();
      e.stopPropagation();
      dismissDropdown();
      return;
    }

    const suggestionEl = e.target.closest('.public-ai-search-suggestion-text');
    

    if (suggestionEl) {
      e.preventDefault();
      e.stopPropagation();
      const query = suggestionEl.dataset.value;
      if (!query) return;

      if (desktopInput) desktopInput.value = query;
      if (mobileInput) mobileInput.value = query;

      const activeInput = currentActiveInput || desktopInput || mobileInput;
      if (activeInput) {
        activeInput.focus();
        activeInput.setSelectionRange(query.length, query.length);
        currentActiveInput = activeInput;
      }

      if (query.length >= PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH) {
        suggestionsLoading = true;
        renderLayout(suggestionSkeletonHTML(), productSkeleton(), false);
        abortController.abort();
        abortController = new AbortController();
        fetchProducts(query);
      }
      return;
    }

    const viewAllLink = e.target.closest('a[href*="/pages/ai-search-result"]');
    if (viewAllLink) {
      e.preventDefault();
      e.stopPropagation();
      const url = new URL(viewAllLink.href);
      const query = url.searchParams.get('q');
      if (query) publicGoToSearchResults(query);
      return;
    }

    const refinementChip = e.target.closest('.public-ai-search-refinement-chip, .public-ai-search-chat-prompt');
    if (refinementChip) {
      e.preventDefault();
      e.stopPropagation();
      handleRefinementChipClick(refinementChip);
      return;
    }

    /* ---------- Sync mouse hover with keyboard highlight ---------- */
    // dropdown.addEventListener('mousemove', (e) => {
    //   for (let i = 0; i < navigableItems.length; i++) {
    //     if (navigableItems[i].contains(e.target)) {
    //       if (i !== highlightedIndex) setHighlight(i);
    //       return;
    //     }
    //   }
    // });

  });

  /* ---------- Chat widget handoff ---------- */
  function handleRefinementChipClick(chip) {
    sessionStorage.setItem('is_history', 'false');

    let chipMessage = chip.dataset.message || chip.textContent.replace(/[➕🎨💰📏✨🔍💬]/g, '').trim();
    let finalMessage = chipMessage;

    if (chip.classList.contains('public-ai-search-refinement-chip')) {
      const originalQuery = currentActiveInput?.value.trim() || lastQuery || '';
      finalMessage = originalQuery ? `${originalQuery} - ${chipMessage}` : chipMessage;
    }

    const promptSuggestion = document.getElementById('gd-chat-widget-prompt_suggestion');
    if (promptSuggestion) promptSuggestion.innerHTML = '';

    let userId = null;
    try {
      userId = localStorage.getItem('user_id');
    } catch (e) {
      // No localStorage access — treat as unregistered
    }

    if (!userId) {
      if (typeof window.showWarning === 'function') {
        window.showWarning('Please sign in to use AI assistance.', 4000);
      }
      const openAssistantBtn = document.getElementById('gd-chat-widget-openAssistantBtn');
      if (openAssistantBtn) openAssistantBtn.click();
      return;
    }

    if (typeof window.gdWidgetToggle !== 'function') {
      console.warn('[Public AI Search] Chat widget not available');
      return;
    }

    const widgetAlreadyOpen = document.body.classList.contains('gd-chatsidebar-open');

    if (!widgetAlreadyOpen) {
      window.gdPendingChipMessage = finalMessage;
      window.gdWidgetToggle(true);
    } else {
      appendUserMessageToChat(finalMessage);
      if (typeof window.gdWidgetChatQuery === 'function') {
        window.gdWidgetChatQuery(finalMessage);
      }
    }
  }

  window.addEventListener('gd-chat-restore-complete', () => {
    if (!window.gdPendingChipMessage) return;
    const msg = window.gdPendingChipMessage;
    window.gdPendingChipMessage = null;
    appendUserMessageToChat(msg);
    if (typeof window.gdWidgetChatQuery === 'function') {
      window.gdWidgetChatQuery(msg);
    }
  });

  function appendUserMessageToChat(message) {
    const area = document.querySelector('.gd-chat-widget-conversation-area');
    if (!area) return;

    const lastUserBubble = area.querySelector(
      '.gd-chat-widget-user-msg .gd-chat-widget-user-bubble:last-child'
    );

    const newMsg = message.trim();
    const oldMsg = lastUserBubble ? lastUserBubble.textContent.trim() : '';
    if (newMsg === oldMsg) return;

    let userInitials = 'G';
    if (typeof window.gdChatWidgetGetUserInitials === 'function') {
      userInitials = window.gdChatWidgetGetUserInitials();
    }

    area.insertAdjacentHTML(
      'beforeend',
      `
      <div class="gd-chat-widget-msg-row gd-chat-widget-user-msg">
        <div class="gd-chat-widget-user-bubble">${publicEscapeHTML(newMsg)}</div>
        <div class="gd-chat-widget-user-avatar">${userInitials}</div>
      </div>
    `
    );

    setTimeout(() => {
      area.scrollTop = area.scrollHeight;
    }, 50);
  }

const TARGET_ACTION = '/pages/ai-search-result';

function ensureSearchAction(form) {
  if (!form) return;
  const currentAction = form.getAttribute('action') || '';
  // Only override if the action contains "search-results-page" (the other app's value)
  // or is anything other than our target
  if (currentAction.includes('search-results-page') || currentAction !== TARGET_ACTION) {
    form.setAttribute('action', TARGET_ACTION);
  }
}

document.querySelectorAll('form[role="search"]').forEach((form) => {
  const input = form.querySelector('input[type="search"]');
  if (!input) return;

  // Override action when user focuses the input
  input.addEventListener('focus', () => ensureSearchAction(form));

  // Override action when user types
  input.addEventListener('input', () => ensureSearchAction(form));

  // Submit handler — captures form submission and redirects via JS
  form.addEventListener(
    'submit',
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const query = input.value.trim();
      if (query.length < PUBLIC_SEARCH_CONFIG.MIN_QUERY_LENGTH) {
        return false; // Block — too short
      }
      publicGoToSearchResults(query);
      return false;
    },
    true
  );

});



})();

/* ============================================================
   PART 2: RESULTS PAGE
============================================================ */
(function () {
  if (!window.location.pathname.includes(PUBLIC_SEARCH_CONFIG.RESULTS_PAGE_PATH)) return;

  const resultContainer = document.getElementById('ai-search-result');
  if (!resultContainer) return;

  const PAGE_CONFIG = {
    INITIAL_PRODUCTS_PER_PAGE: 12,
    LOAD_MORE_COUNT: 12,
    API_ITEMS_PER_PAGE: 15,
    PRODUCT_CARD_VIEW: 'ajax-view-product-card',
    CONCURRENCY_LIMIT: 3,
  };

  const urlParams = new URLSearchParams(window.location.search);
  let currentQuery = urlParams.get('q') || '';
  const urlPage = parseInt(urlParams.get('page')) || 1;

  const desktopInput = document.getElementById('Search-In-Modal-Single');
  const mobileInput = document.querySelector('.search-for-mobile-input');
  if (desktopInput && currentQuery) desktopInput.value = currentQuery;
  if (mobileInput && currentQuery) mobileInput.value = currentQuery;

  /* ---------- State ---------- */
  let apiSuggestions = [];
  let collectionsData = [];

  let currentPage = urlPage;
  let totalProducts = 0;
  let totalPages = 0;
  let allProducts = [];
  let displayedCount = 0;
  let isLoadingMore = false;
  let fetchedPages = new Set();

  // ⭐ NEW: flag to indicate we're showing best-sellers fallback (no infinite scroll, no pagination)
  let isShowingBestSellersFallback = false;

  let observer = null;
  let sentinel = null;

  /* ---------- Render: suggestions ---------- */
  function renderSuggestions(query) {
    const columnsHTML = publicRenderSuggestionColumns(
      query,
      apiSuggestions,
      collectionsData,
      'public-ai-search-page'
    );
    if (!columnsHTML) return '';
    return `<div class="public-ai-search-page-suggestion-container">${columnsHTML}</div>`;
  }


  function updateDocumentTitle(query) {
    const h1 = document.querySelector('.main-page-title.page-header');

    if (query && query.trim()) {
      const priceInfo = publicFormatSearchDisplay(query);
      if (priceInfo.isPrice) {
        document.title = `Prices under ${priceInfo.priceValue} | Goddiva`;
      } else {
        const titled = query.trim().replace(/\b\w/g, (c) => c.toUpperCase());
        document.title = `${titled} Search Results | Goddiva`;
      }
    } else {
      document.title = 'Search | Goddiva';
    }
  }

  /* ---------- Init ---------- */
  updateDocumentTitle(currentQuery);
  // if (currentQuery) {
  //   showInitialLoading();
  //   publicLocalSuggestionsReady.finally(() => fetchInitialProducts(currentQuery));
  // } else {
  //   resultContainer.innerHTML = `...`;
  // }

  /* ---------- Render: header ---------- */
  function renderPageHeader() {
    // ⭐ When showing best-sellers fallback, render a different header
    if (isShowingBestSellersFallback) {
      return `
        <div style="margin-bottom: 24px;">
          <div style="padding: 16px; background: #fef3c7; border-radius: 8px; margin-bottom: 16px;">
            <h2 style="margin: 0 0 4px 0; font-size: 16px; color: #92400e; font-weight: 600;">
              No products found for "${publicEscapeHTML(currentQuery)}"
            </h2>
            <p style="margin: 0; font-size: 14px; color: #6b7280;">
              Here are some of our best sellers you might like
            </p>
          </div>
          <h3 style="margin: 0; color: #111827; font-size: 18px; font-weight: 600;">Best Sellers</h3>
        </div>
      `;
    }

    let headerText = '';
      if (totalProducts !== 0) {
        const priceInfo = publicFormatSearchDisplay(apiReturnedQuery || currentQuery);
        if (priceInfo.isPrice) {
          headerText = `Showing Search results for Prices under "<span class="public-ai-search-page-search-term-highlight">${publicEscapeHTML(priceInfo.priceValue)}</span>"`;
        } else {
          // Check if the typed query had a spelling correction
          headerText = `Search Results for: "<span class="public-ai-search-page-search-term-highlight">${publicEscapeHTML(currentQuery)}</span>"`;
        }
      }

    return `
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; flex-wrap: wrap; gap: 16px;">
        <h2 style="margin: 0; color: #6b7280; font-size: 15px; font-weight: 400;">${headerText}</h2>
        <div style="color: #6b7280; font-size: 14px;">
          Showing <span style="font-weight: 600; color: #111827;">${displayedCount}</span> of
          <span style="font-weight: 600; color: #111827;">${totalProducts}</span> products
        </div>
      </div>
    `;
  }

  
  function updatePageHeader() {
  const headerContainer = document.getElementById('public-ai-search-page-header');
  if (headerContainer) {
    headerContainer.innerHTML = renderPageHeader();
  }
}
  /* ---------- Render: product grid ---------- */
  function renderProductsGrid(products) {
    if (!products.length) {
      return `
        <div style="padding: 40px; text-align: center;">
          <h3 style="margin-bottom: 8px;">No products found for "${publicEscapeHTML(currentQuery)}"</h3>
          <p style="color: #6b7280;">Try adjusting your search terms.</p>
        </div>
      `;
    }

    return `
      <div style="padding: 20px 0 0 0;">
        <div id="public-ai-search-page-header">${renderPageHeader()}</div>
        <div class="public-ai-search-page-products productListing productGrid column-4 list-4 list-unstyled">
          ${products.map((item, index) => renderCardHolder(item, index)).join('')}
        </div>
      </div>
    `;
  }

  function renderCardHolder(item, index) {
    return `
      <div class="public-ai-search-page-card-holder product"
           data-handle="${item.handle}"
           data-url="/products/${item.handle}"
           data-index="${index}"
           style="min-height: 400px; position: relative;">
        <div class="public-ai-spinner-modern" style="display: inline-block; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"> </div>
      </div>
    `;
  }

  function appendProductPlaceholders(products, startIndex) {
    const grid = resultContainer.querySelector('.public-ai-search-page-products');
    if (!grid) return;
    const placeholdersHTML = products.map((item, i) => renderCardHolder(item, startIndex + i)).join('');
    grid.insertAdjacentHTML('beforeend', placeholdersHTML);
  }

  /* ---------- Load product cards (Shopify view) ---------- */
  async function loadProductTemplates(filterFn = null) {
    const allHolders = document.querySelectorAll('.public-ai-search-page-card-holder:not(.loaded)');
    const holdersArray = filterFn ? Array.from(allHolders).filter(filterFn) : Array.from(allHolders);
    if (holdersArray.length === 0) return;

    for (let i = 0; i < holdersArray.length; i += PAGE_CONFIG.CONCURRENCY_LIMIT) {
      const batch = holdersArray.slice(i, i + PAGE_CONFIG.CONCURRENCY_LIMIT);

      await Promise.all(
       batch.map(async (holder) => {
          const productUrl = holder.getAttribute('data-url');
          try {
            const templateResp = await fetch(`${productUrl}?view=${PAGE_CONFIG.PRODUCT_CARD_VIEW}`);

            // 404 / 410 → product no longer exists; drop the placeholder silently
            if (templateResp.status === 404 || templateResp.status === 410) {
              holder.remove();
              return;
            }

            if (!templateResp.ok) {
              throw new Error(`HTTP ${templateResp.status} for ${productUrl}`);
            }

            const templateHTML = await templateResp.text();

            if (!templateHTML || templateHTML.includes('<html')) {
              holder.remove();
              return;
            }

            holder.innerHTML = templateHTML;
            holder.classList.add('loaded');
            // ⭐ A11Y: ensure the card is reachable by Tab
            const link = holder.querySelector('a[href]');
            if (link && link.getAttribute('tabindex') === '-1') {
              link.removeAttribute('tabindex');
            }

            if (typeof window.initializeProductCards === 'function') {
              setTimeout(() => window.initializeProductCards(holder), 100);
            }
          } catch (err) {
            console.error('Error fetching product card:', err);
            // Any other failure → remove placeholder so user doesn't see a stuck spinner
            holder.remove();
          }
        })
      );

      if (i + PAGE_CONFIG.CONCURRENCY_LIMIT < holdersArray.length) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
    }
  }

  /* ---------- Pagination helpers ---------- */
  const calculateProductsToShowForPage = (page) => page * PAGE_CONFIG.INITIAL_PRODUCTS_PER_PAGE;
  const calculateApiPagesNeeded = (productCount) => Math.ceil(productCount / PAGE_CONFIG.API_ITEMS_PER_PAGE);

  function getPagesToFetch(targetProductCount) {
    const productsNeeded = targetProductCount - allProducts.length;
    if (productsNeeded <= 0) return [];

    const pagesNeeded = Math.ceil(productsNeeded / PAGE_CONFIG.API_ITEMS_PER_PAGE);
    const startPage = Math.floor(allProducts.length / PAGE_CONFIG.API_ITEMS_PER_PAGE) + 1;
    const pages = [];

    for (let i = 0; i < pagesNeeded; i++) {
      const pageNumber = startPage + i;
      if (pageNumber <= totalPages && !fetchedPages.has(pageNumber)) {
        pages.push(pageNumber);
      }
    }
    return pages;
  }

  function fetchMultiplePages(pages) {
    if (!pages.length) return Promise.resolve([]);

    const promises = pages.map((page) => {
      if (fetchedPages.has(page)) return Promise.resolve([]);

      return publicSearchAuthFetch(PUBLIC_SEARCH_CONFIG.SEARCH_URL, {
        method: 'POST',
        body: JSON.stringify({ query: currentQuery, page, per_page: PAGE_CONFIG.API_ITEMS_PER_PAGE }),
      })
        .then((response) => {
          if (!response) throw new Error('auth');
          if (!response.ok) throw new Error(`HTTP ${response.status} for page ${page}`);
          return response.json();
        })
        .then((data) => {
          fetchedPages.add(page);
          return data?.items?.flat() || [];
        })
        .catch((error) => {
          console.error(`Error fetching page ${page}:`, error);
          return [];
        });
    });

    return Promise.all(promises).then((pagesData) => pagesData.flat());
  }

  /* ---------- Infinite scroll sentinel ---------- */
  function createSentinel() {
    if (sentinel && sentinel.parentNode) return sentinel;

    sentinel = document.createElement('div');
    sentinel.id = 'public-ai-search-page-sentinel';
    sentinel.style.cssText = 'height: 20px; width: 100%; margin: 20px 0; text-align: center; padding: 10px 0;';
    sentinel.innerHTML = `
      <div class="public-ai-spinner-modern" style="display: none;"> </div>
      <div class="public-ai-search-page-sentinel-text" style="font-size: 14px; color: #6b7280;"> </div>
    `;
    updateSentinelText(false);
    return sentinel;
  }

  function updateSentinelText(loading) {
    if (!sentinel) return;
    const spinner = sentinel.querySelector('.public-ai-spinner-modern');
    const textEl = sentinel.querySelector('.public-ai-search-page-sentinel-text');
    if (spinner) spinner.style.display = loading ? 'inline-block' : 'none';

    const remaining = totalProducts - displayedCount;
    if (textEl) {
      if (loading) {
        textEl.textContent = `loading more, remaining ${remaining} product${remaining !== 1 ? 's' : ''}`;
      } else {
        textEl.textContent = remaining > 0 ? `${remaining} product${remaining !== 1 ? 's' : ''} remaining` : ' ';
      }
    }
  }

  function setupInfiniteScroll() {
    // ⭐ Skip infinite scroll when showing best-sellers fallback
    if (isShowingBestSellersFallback) return;

    if (observer) observer.disconnect();

    const existingSentinel = document.getElementById('public-ai-search-page-sentinel');
    sentinel = existingSentinel || createSentinel();
    if (!existingSentinel) resultContainer.appendChild(sentinel);

    sentinel.style.display = 'block';
    updateSentinelText(false);

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && displayedCount < totalProducts && !isLoadingMore) {
            updateSentinelText(true);
            loadMoreProducts();
          }
        });
      },
      { root: null, rootMargin: '0px 0px 200px 0px', threshold: 0.1 }
    );

    observer.observe(sentinel);
  }

  /* ---------- Load more ---------- */
  async function loadMoreProducts() {
    if (isLoadingMore || displayedCount >= totalProducts) return;
    if (isShowingBestSellersFallback) return; // ⭐ no pagination for fallback

    isLoadingMore = true;
    updateSentinelText(true);

    const targetDisplayCount = Math.min(displayedCount + PAGE_CONFIG.LOAD_MORE_COUNT, totalProducts);
    const previousDisplayedCount = displayedCount;
    const pagesToFetch = getPagesToFetch(targetDisplayCount);

    try {
      if (pagesToFetch.length > 0) {
        const newProducts = await fetchMultiplePages(pagesToFetch);
        if (newProducts?.length) allProducts = [...allProducts, ...newProducts];
      }

      displayedCount = Math.min(targetDisplayCount, allProducts.length);
      currentPage = Math.ceil(displayedCount / PAGE_CONFIG.INITIAL_PRODUCTS_PER_PAGE);
      updatePageHeader();

      const newProductsToShow = allProducts.slice(previousDisplayedCount, displayedCount);
      appendProductPlaceholders(newProductsToShow, previousDisplayedCount);

      await loadProductTemplates((holder) => {
        const idx = parseInt(holder.getAttribute('data-index') || '0');
        return idx >= previousDisplayedCount;
      });
    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      isLoadingMore = false;
      updateSentinelText(false);

      if (displayedCount >= totalProducts && sentinel) {
        observer.unobserve(sentinel);
        sentinel.remove();
        sentinel = null;
      } else if (sentinel && observer) {
        observer.unobserve(sentinel);
        observer.observe(sentinel);
      }
    }
  }

  /* ---------- Suggestion handlers ---------- */
function attachSuggestionHandlers() {
  document.querySelectorAll('.public-ai-search-page-suggestion-text').forEach((span) => {
    // ⭐ A11Y: make tabbable
    span.setAttribute('tabindex', '0');
    span.setAttribute('role', 'button');

    span.addEventListener('click', () => {
      const newQuery = span.getAttribute('data-value');
      if (newQuery && newQuery !== currentQuery) performSearch(newQuery, 1);
    });

    // ⭐ A11Y: keyboard activation
    span.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        span.click();
      }
    });
  });
}

  

  function renderSuggestionsSection(query) {
    const suggestionsHTML = renderSuggestions(query);
    if (!suggestionsHTML) return;

    let suggestionsContainer = document.getElementById('public-ai-search-page-suggestions');
    if (!suggestionsContainer) {
      suggestionsContainer = document.createElement('div');
      suggestionsContainer.id = 'public-ai-search-page-suggestions';
      resultContainer.insertBefore(suggestionsContainer, resultContainer.firstChild);
    }
    suggestionsContainer.innerHTML = suggestionsHTML;
    attachSuggestionHandlers();
  }

  function performSearch(newQuery, page = 1) {
    if (!newQuery) return;

    currentQuery = newQuery;
    updateDocumentTitle(newQuery);
    if (desktopInput) desktopInput.value = newQuery;
    if (mobileInput) mobileInput.value = newQuery;

    const newUrl = new URL(window.location);
    newUrl.searchParams.set('q', newQuery);
    newUrl.searchParams.delete('page');
    history.pushState({}, '', newUrl);

    currentPage = page;
    totalProducts = 0;
    totalPages = 0;
    allProducts = [];
    displayedCount = 0;
    isLoadingMore = false;
    fetchedPages.clear();
    isShowingBestSellersFallback = false; // ⭐ reset on new search
    if (observer) observer.disconnect();
    if (sentinel) sentinel.remove();
    sentinel = null;

    showInitialLoading();
    fetchInitialProducts(currentQuery);
  }

  /* ---------- Browser back/forward sync ---------- */
window.addEventListener('popstate', () => {
  const params = new URLSearchParams(window.location.search);
  const urlQuery = params.get('q') || '';
  const urlPageFromHistory = parseInt(params.get('page')) || 1;

  // If URL query matches what we already have, nothing to do
  if (urlQuery === currentQuery && urlPageFromHistory === currentPage) return;

  if (!urlQuery) {
    // Reset to empty state
    currentQuery = '';
    if (desktopInput) desktopInput.value = '';
    if (mobileInput) mobileInput.value = '';
    resultContainer.innerHTML = `
      <div style="padding: 40px; text-align: center;">
        <div style="font-size: 48px; margin-bottom: 16px;">🔍</div>
        <h3 style="margin-bottom: 8px;">No search query provided</h3>
        <p style="color: #6b7280;">Please enter a search term to see results.</p>
      </div>
    `;
    return;
  }

  // Fully reset state and re-fetch for the URL's query.
  currentQuery = urlQuery;
  updateDocumentTitle(urlQuery);
  if (desktopInput) desktopInput.value = urlQuery;
  if (mobileInput) mobileInput.value = urlQuery;

  currentPage = urlPageFromHistory;
  totalProducts = 0;
  totalPages = 0;
  allProducts = [];
  displayedCount = 0;
  isLoadingMore = false;
  fetchedPages.clear();
  apiSuggestions = [];
  collectionsData = [];
  isShowingBestSellersFallback = false; // ⭐ reset on history nav
  if (observer) observer.disconnect();
  if (sentinel) {
    sentinel.remove();
    sentinel = null;
  }

  showInitialLoading();
  fetchInitialProducts(currentQuery);
});

  function updateDisplayedProducts() {
    const productsToShow = allProducts.slice(0, displayedCount);
    resultContainer.innerHTML = renderProductsGrid(productsToShow);
    renderSuggestionsSection(currentQuery);
   

    loadProductTemplates()
      .then(() => {
        if (displayedCount < totalProducts) setupInfiniteScroll();
      })
      .catch((error) => {
        console.error('Error loading product templates:', error);
        if (displayedCount < totalProducts) setupInfiniteScroll();
      });
  }

  function showInitialLoading(message) {
    const heading = message
      ? `<h2 style="margin-bottom: 16px;">${message}</h2>`
      : `<h2 style="margin-bottom: 16px;">Search Results for: "${publicEscapeHTML(currentQuery)}"</h2>`;
    resultContainer.innerHTML = `
      <div style="padding: 20px; text-align: center;">
        ${heading}
        <div class="public-ai-spinner-modern" style="display: inline-block;"> </div>
        <div style="font-size: 14px; color: #6b7280; margin-top: 8px;">Loading products...</div>
      </div>
    `;
  }

  /* ---------- Best Sellers fallback for results page ---------- */
  function showBestSellersFallback(query) {
    publicLoadBestSellers().then((bestSellers) => {
      const products = bestSellers?.products || [];

      if (!products.length) {
        // Best sellers also empty — show plain no-results message
        resultContainer.innerHTML = `
          <div style="padding: 40px; text-align: center;">
            <h3 style="margin-bottom: 8px;">No products found for "${publicEscapeHTML(query)}"</h3>
            <p style="color: #6b7280;">Try adjusting your search terms.</p>
          </div>
        `;
        renderSuggestionsSection(query);
        return;
      }

      // Set fallback state and populate as if these were normal results
      isShowingBestSellersFallback = true;
      allProducts = products;
      totalProducts = products.length;
      totalPages = 1;
      displayedCount = products.length; // show all best sellers, no pagination
      fetchedPages.add(1);

      updateDisplayedProducts();
    });
  }

  /* ---------- Initial fetch ---------- */
  function fetchInitialProducts(query) {
    publicSearchAuthFetch(PUBLIC_SEARCH_CONFIG.SEARCH_URL, {
      method: 'POST',
      body: JSON.stringify({ query }),
    })
      .then((response) => {
        if (!response) throw new Error('auth');
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        const products = data?.items?.flat() || [];

        apiSuggestions = data.suggestions || [];
        collectionsData = publicDedupeCollections(data.collections);
        apiReturnedQuery = data.query || currentQuery;

        if (!products.length) {
          // ⭐ Zero results — show best sellers fallback (suggestions still rendered)
          console.log('🚫 [ResultsPage] Zero results for "' + query + '", loading best sellers fallback');
          showBestSellersFallback(query);
          return;
        }

        allProducts = products;
        totalProducts = data.total || allProducts.length;
        totalPages = data.total_pages || 1;
        fetchedPages.add(1);

        const targetProductsToShow = Math.min(calculateProductsToShowForPage(currentPage), totalProducts);
        displayedCount = Math.min(targetProductsToShow, totalProducts);

        const apiPagesNeeded = calculateApiPagesNeeded(displayedCount);

        if (apiPagesNeeded > 1) {
          const additionalPages = [];
          for (let page = 2; page <= Math.min(apiPagesNeeded, totalPages); page++) {
            additionalPages.push(page);
          }

          if (additionalPages.length > 0) {
            showInitialLoading(`Loading page ${currentPage} of results...`);
            fetchMultiplePages(additionalPages)
              .then((newProducts) => {
                if (newProducts?.length) allProducts = [...allProducts, ...newProducts];
                displayedCount = Math.min(targetProductsToShow, allProducts.length);
                updateDisplayedProducts();
              })
              .catch((error) => {
                console.error('Error fetching additional pages:', error);
                displayedCount = Math.min(targetProductsToShow, allProducts.length);
                updateDisplayedProducts();
              });
          } else {
            updateDisplayedProducts();
          }
        } else {
          updateDisplayedProducts();
        }
      })
      .catch((error) => {
        console.error('Error fetching initial products:', error);
        resultContainer.innerHTML = `
          <div style="padding: 40px; text-align: center;">
            <div style="font-size: 48px; margin-bottom: 16px;">⚠️</div>
            <h3 style="margin-bottom: 8px;">Error loading results</h3>
            <p style="color: #6b7280; margin-bottom: 16px;">
              ${error.message === 'auth' ? 'Authentication failed. Please refresh the page.' : 'Please try again or check your connection.'}
            </p>
            <button onclick="window.location.reload()"
                    style="margin-top: 16px; padding: 10px 20px; background: #3b82f6; color: white; border: none; border-radius: 6px; cursor: pointer;">
              Retry
            </button>
          </div>
        `;
      });
  }

  /* ---------- Init ---------- */
  if (currentQuery) {
    showInitialLoading();
    publicLocalSuggestionsReady.finally(() => fetchInitialProducts(currentQuery));
  } else {
    resultContainer.innerHTML = `
      <div style="padding: 40px; text-align: center;">
        <div style="font-size: 48px; margin-bottom: 16px;">🔍</div>
        <h3 style="margin-bottom: 8px;">No search query provided</h3>
        <p style="color: #6b7280;">Please enter a search term to see results.</p>
      </div>
    `;
  }
})();